import { assignSubComponents } from '@farol-ds/react/utilities/internal'
import * as RToggleGroup from '@radix-ui/react-toggle-group'
import { useControllableState } from '@radix-ui/react-use-controllable-state'
import classNames from 'classnames'
import { forwardRef } from 'react'

import styles from './segmented-control.module.scss'
import SegmentedControlItem from './segmented-control-item'

export type SegmentedControlElement = HTMLDivElement

export interface SegmentedControlProps extends Omit<RToggleGroup.ToggleGroupSingleProps, 'type'> {
  block?: boolean
}

const SegmentedControlRoot = forwardRef<SegmentedControlElement, SegmentedControlProps>(
  function SegmentedControl(props, forwardedRef) {
    const {
      className,
      children,
      block = false,
      value: valueProp,
      defaultValue: defaultValueProp,
      onValueChange: onValueChangeProp,
      ...rootProps
    } = props

    const [value, setValue] = useControllableState({
      prop: valueProp,
      onChange: onValueChangeProp,
      defaultProp: defaultValueProp ?? '',
    })

    const classes = classNames(
      styles.root,
      {
        [styles.block]: block,
      },
      className
    )

    return (
      <RToggleGroup.Root
        onValueChange={(value) => {
          if (value) {
            setValue(value)
          }
        }}
        {...rootProps}
        value={value}
        type="single"
        className={classes}
        ref={forwardedRef}
      >
        {children}
      </RToggleGroup.Root>
    )
  }
)

export const SegmentedControl = assignSubComponents('SegmentedControl', SegmentedControlRoot, {
  Item: SegmentedControlItem,
})

export * from './segmented-control-item'
